import React from 'react'
import { cn } from '../../lib/utils'

const PLAN_LABELS = {
  starter: 'Starter',
  club: 'Club',
  pro: 'Pro',
  torneos_free: 'Free',
  torneos_pro: 'Pro',
}

const PLAN_CLASSES = {
  starter: 'bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-200',
  club: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  pro: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  torneos_free: 'bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-200',
  torneos_pro: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
}

const PlanBadge = ({ plan = 'starter', className }) => {
  const code = PLAN_LABELS[plan] ? plan : 'starter'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        PLAN_CLASSES[code],
        className
      )}
    >
      Plan {PLAN_LABELS[code]}
    </span>
  )
}

export default PlanBadge
